document.addEventListener('DOMContentLoaded', function(){
  if(!window.HYDRUP){ /* core.js not ready */ return; }
  (function(){
  "use strict";
  const $=(s,c=document)=>c.querySelector(s);
  const $$=(s,c=document)=>[...c.querySelectorAll(s)];
  const H=window.HYDRUP;

  /* URL del producto: usa la URL real de Shopify (del puente, si está asignado);
     si no, el handle conocido del single; si no (packs aún sin crear), la sección productos. */
  const HANDLES={maracuya:'hydrup-te-maracuya','frutos-rojos':'hydrup-frutos-rojos',naranja:'hydrup-naranja',limon:'hydrup-limon',mix:'hydrup-mix-1','sin-sabor':'hydrup-neutro'};
  const pUrl=p=>(p&&p.url)||(p&&HANDLES[p.id]?'/products/'+HANDLES[p.id]:'#productos');

  /* Mini "corte de fruta" SVG (compartido: sabores + suscripción) */
  const TAU=Math.PI*2;
  function fruitMini(p){
    if(p.id==='sin-sabor') return `<svg viewBox="0 0 100 100"><circle cx="50" cy="50" r="46" fill="#EAF6FB"/><circle cx="50" cy="50" r="46" fill="#9FD8EC" opacity=".5"/><path d="M50 24c0 0-13 18-13 30a13 13 0 0026 0c0-12-13-30-13-30z" fill="#fff" opacity=".85"/></svg>`;
    const segs=10;
    let lines='';
    for(let i=0;i<segs;i++){const a=i/segs*TAU;lines+=`<line x1="50" y1="50" x2="${(50+Math.cos(a)*40).toFixed(1)}" y2="${(50+Math.sin(a)*40).toFixed(1)}" stroke="#fff" stroke-width="1.6" stroke-opacity=".8"/>`;}
    let wedges='';
    if(p.id==='mix'){const cols=['#8E44AD','#D32F45','#F08A1E','#A9C72E','#2FA5D4','#EE9F5C'];for(let i=0;i<segs;i++){const a0=i/segs*TAU-Math.PI/2,a1=(i+1)/segs*TAU-Math.PI/2;wedges+=`<path d="M50 50 L${(50+Math.cos(a0)*40).toFixed(1)} ${(50+Math.sin(a0)*40).toFixed(1)} A40 40 0 0 1 ${(50+Math.cos(a1)*40).toFixed(1)} ${(50+Math.sin(a1)*40).toFixed(1)} Z" fill="${cols[i%cols.length]}" opacity=".9"/>`;}}
    let seeds='';
    if(p.id==='frutos-rojos'||p.id==='maracuya'){for(let i=0;i<10;i++){const a=i/10*TAU+0.3,r=14+(i%2)*10;seeds+=`<circle cx="${(50+Math.cos(a)*r).toFixed(1)}" cy="${(50+Math.sin(a)*r).toFixed(1)}" r="1.7" fill="${p.id==='maracuya'?'#3a2a12':'#fff'}" opacity=".75"/>`;}}
    return `<svg viewBox="0 0 100 100"><circle cx="50" cy="50" r="47" fill="${p.swatch}"/><circle cx="50" cy="50" r="42" fill="#fff"/><circle cx="50" cy="50" r="40" fill="${p.cl}"/>${p.id==='mix'?wedges:`<circle cx="50" cy="50" r="40" fill="${p.swatch}" opacity=".22"/>`}${lines}${seeds}<circle cx="50" cy="50" r="6" fill="#fff" opacity=".75"/></svg>`;
  }

  /* NAV: el menú y el resaltado de sección viven en hydrup-core.js (se carga en todas las
     páginas). Aquí solo queda el CTA fijo, que es exclusivo de la home. */
  window.addEventListener('scroll', toggleSticky, {passive:true});

  /* Reveal */
  const revObs=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');revObs.unobserve(e.target);}}),{threshold:.12});
  $$('.reveal').forEach(el=>revObs.observe(el));

  /* Vídeo diferido: no se descarga (~1,5 MB) hasta que el usuario se acerca a la sección.
     El margen de 300px lo deja arrancado justo antes de entrar en pantalla. */
  const lazyVids=$$('video[data-src]');
  if(lazyVids.length){
    const vidObs=new IntersectionObserver(es=>es.forEach(e=>{
      if(!e.isIntersecting) return;
      const v=e.target; vidObs.unobserve(v);
      v.src=v.dataset.src; delete v.dataset.src;
      v.play().catch(()=>{}); // si el navegador lo bloquea, se queda el póster
    }),{rootMargin:'300px 0px'});
    lazyVids.forEach(v=>vidObs.observe(v));
  }

  /* Sabores: lista + foto que cambia (hover/tap) -> PDP */
  const flist=$('#flavorList'), fprev=$('#flavorPreview');
  if(flist&&fprev){
    const FL=H.products.filter(p=>p.cat==='single');
    const nm=p=>({'sin-sabor':'Sin sabor','mix':'Variado'}[p.id]||p.name);
    const arrow='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';
    flist.innerHTML=FL.map((p,i)=>`
      <button class="flavor-row${i===0?' active':''}" data-i="${i}" type="button" style="--swatch:${p.swatch}">
        <span class="fr-slice">${fruitMini(p)}</span>
        <span class="fr-meta"><strong>${p.name}</strong><span>${p.tagline}</span></span>
        ${p.badge?`<span class="pill pill-new">${p.badge}</span>`:''}
        <span class="fr-go">${arrow}</span>
      </button>`).join('');
    function setActive(i){
      const p=FL[i];
      $$('.flavor-row',flist).forEach(r=>r.classList.toggle('active',+r.dataset.i===i));
      fprev.style.setProperty('--c',p.swatch);
      fprev.setAttribute('href',pUrl(p));
      const _si=p.bottle||p.img; const _sf=p.bottle?'cover':(p.imgFit||'cover'); const _c=_sf==='contain'?' fp-contain':''; const _ss=H.SRCSET(_si,[300,500,700]); const vis=_si?`<img class="fp-photo${_c}" src="${_si}"${_ss?` srcset="${_ss}" sizes="(max-width:900px) 60vw, 340px"`:''} alt="Hydrup ${p.name}" loading="lazy" decoding="async">`:`<div class="fp-slice">${fruitMini(p)}</div>`;
      fprev.innerHTML=`${vis}<span class="fp-cta">Comprar ${nm(p)} ${arrow}</span>`;
    }
    $$('.flavor-row',flist).forEach(r=>{
      const i=+r.dataset.i;
      r.addEventListener('mouseenter',()=>setActive(i));
      r.addEventListener('focus',()=>setActive(i));
      r.addEventListener('click',()=>setActive(i));
    });
    setActive(0);
  }

  /* Bloque de compra de la tarjeta: SOLO compra única. La suscripción se retiró de la
     tienda (24-ago-2026), así que la tarjeta enseña el precio como los packs en vez del
     selector de dos opciones. `subPrice` se conserva porque la sección #suscripcion
     (desactivada en el editor) todavía lo usa si se reactiva. */
  const subPrice=p=>+(p.price*(1-H.SUB_RATE)).toFixed(2);
  function buyBlock(p){
    return `<div class="card-price"><span class="now">${H.eur(p.price)}</span>${p.was?`<span class="was">${H.eur(p.was)}</span>`:''}${p.unit?`<span class="unit">${p.unit}</span>`:''}</div>
      <button class="btn btn-primary add-btn" data-id="${p.id}">Añadir al carrito
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg></button>`;
  }

  /* Productos por grupos */
  /* En la tarjeta el formato ya lo dicen la fila de formato y la etiqueta de la foto: el título queda
     en el sabor y el subtítulo en la nota de sabor (el nombre completo sigue en carrito y pedidos). */
  const cardName=p=>p.cat==='single'?p.name.replace(/\s*·\s*\d+\s*sticks\s*$/i,''):p.name;
  const cardDesc=p=>p.cat==='single'?String(p.desc||'').replace(/^\s*\d+\s*sticks\s*·\s*/i,''):p.desc;
  function card(p){
    const _ss=H.SRCSET(p.img,[300,450,700,900,1080]);
    const media=p.img?`<img class="${p.imgFit||'contain'}" src="${p.img}"${_ss?` srcset="${_ss}" sizes="(max-width:560px) 80vw, (max-width:900px) 45vw, 380px"`:''} alt="${p.name}" loading="lazy" decoding="async" />`:H.sachet(p.swatch);
    return `<article class="card" data-cat="${p.cat}">
      <a class="card-link" href="${pUrl(p)}" aria-label="${p.name}">
        <div class="card-media fit-${p.imgFit||'contain'}" style="--c-light:${p.cl}">
          ${p.badge?`<span class="card-badge ${p.save?'save':''}">${p.badge}</span>`:''}
          ${p.qty||p.cat==='single'?`<span class="qty-badge">${p.qty||'16 sticks'}</span>`:''}
          ${media}
        </div>
      </a>
      <div class="card-body">
        <div class="card-rate"><span class="stars">★★★★★</span> ${p.rate} · ${p.reviews} reseñas</div>
        <h3><a href="${pUrl(p)}">${cardName(p)}</a></h3>
        <p class="card-desc">${cardDesc(p)}</p>
        ${p.cat==='pack'
          ? `<div class="card-price"><span class="now">${H.eur(p.price)}</span>${p.was?`<span class="was">${H.eur(p.was)}</span>`:''}<span class="unit">${p.unit}</span></div>
             ${p.was?`<div class="save-row"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg> Te ahorras <strong>${H.eur(p.was-p.price)}</strong></div>`:''}
             <a class="btn btn-primary" href="${pUrl(p)}">Elegir sabores
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg></a>`
          : buyBlock(p)}
      </div>
    </article>`;
  }
  const grid=$('#prodGrid');
  function bindAdds(scope){
    scope=scope||grid;
    $$('.add-btn',scope).forEach(btn=>btn.onclick=()=>{
      const p=H.getProduct(btn.dataset.id);
      H.addToCart(p.name,p.price,false,p.img,1,p.id);
    });
  }
  function renderProducts(cat){
    grid.innerHTML=H.products.filter(p=>p.cat===cat).map(card).join('');
    $$('.card',grid).forEach((c,i)=>{c.classList.add('reveal');setTimeout(()=>c.classList.add('in'),40*i+30);});
    bindAdds();
  }
  const cS=$('#countSingle'),cP=$('#countPack');
  if(cS)cS.textContent=H.products.filter(p=>p.cat==='single').length;
  if(cP)cP.textContent=H.products.filter(p=>p.cat==='pack').length;
  $$('#prodTabs button').forEach(b=>b.addEventListener('click',()=>{
    $$('#prodTabs button').forEach(x=>x.classList.remove('active'));
    b.classList.add('active'); renderProducts(b.dataset.tab);
  }));
  renderProducts('single');

  /* Packs: sección propia (#packGrid). Reutiliza la misma tarjeta que los individuales. */
  const packGrid=$('#packGrid');
  if(packGrid){
    packGrid.innerHTML=H.products.filter(p=>p.cat==='pack').map(card).join('');
    $$('.card',packGrid).forEach((c,i)=>{c.classList.add('reveal');setTimeout(()=>c.classList.add('in'),40*i+30);});
  }

  /* Carruseles (bolsas 16 / cajas 30): flechas que avanzan una "página" y se ocultan en los extremos.
     Autoavance de una tarjeta cada 4 s (vuelve al inicio al final) para que se note que hay más a la
     derecha: solo con el carrusel en pantalla, en pausa mientras el usuario lo toca y unos segundos
     después, desfasado entre carruseles y desactivado con prefers-reduced-motion. */
  const reduceMotion=matchMedia('(prefers-reduced-motion: reduce)').matches;
  $$('[data-carousel]').forEach((car,ci)=>{
    const track=$('.prod-grid',car),prev=$('.car-arrow.prev',car),next=$('.car-arrow.next',car);
    if(!track||!prev||!next)return;
    let visible=false,pausedUntil=0,hover=false;
    const hold=(ms=8000)=>{pausedUntil=Date.now()+ms;};
    const step=dir=>track.scrollBy({left:dir*track.clientWidth,behavior:'smooth'});
    const max=()=>track.scrollWidth-track.clientWidth;
    const sync=()=>{prev.disabled=track.scrollLeft<=8;next.disabled=track.scrollLeft>=max()-8;};
    prev.onclick=()=>{hold();step(-1);};next.onclick=()=>{hold();step(1);};
    track.addEventListener('scroll',sync,{passive:true});addEventListener('resize',sync);sync();

    if(reduceMotion)return;
    const cardStep=()=>{const c=track.children;return c.length>1?c[1].offsetLeft-c[0].offsetLeft:track.clientWidth;};
    const tick=()=>{
      if(!visible||hover||Date.now()<pausedUntil||max()<=8)return;
      if(track.scrollLeft>=max()-8)track.scrollTo({left:0,behavior:'smooth'});
      else track.scrollBy({left:cardStep(),behavior:'smooth'});
    };
    car.addEventListener('mouseenter',()=>{hover=true;});
    car.addEventListener('mouseleave',()=>{hover=false;hold(2500);});
    ['touchstart','pointerdown','wheel','keydown','focusin'].forEach(ev=>car.addEventListener(ev,()=>hold(),{passive:true}));
    new IntersectionObserver(es=>{visible=es[0].isIntersecting;},{threshold:.5}).observe(track);
    setTimeout(()=>setInterval(tick,4000),ci*2000);
  });

  /* FAQ */
  $$('.faq-q').forEach(q=>q.addEventListener('click',()=>{
    const item=q.parentElement,a=q.nextElementSibling,open=item.classList.contains('open');
    $$('.faq-item').forEach(it=>{it.classList.remove('open');it.querySelector('.faq-a').style.maxHeight=null;});
    if(!open){item.classList.add('open');a.style.maxHeight=a.scrollHeight+'px';}
  }));

  /* Sticky CTA */
  const stickyCta=$('#stickyCta');
  function toggleSticky(){
    if(!stickyCta) return;
    const sub=$('#suscripcion'), foot=$('footer');
    if(!sub||!foot) return;
    const subTop=sub.getBoundingClientRect().top, footTop=foot.getBoundingClientRect().top;
    stickyCta.classList.toggle('show',window.scrollY>700&&(subTop>window.innerHeight||subTop<0)&&footTop>window.innerHeight+100);
  }

  /* Suscripción: elegir sabor (píldoras) — se aplica a ambas opciones */
  const pills=$('#subFlavorPills');
  if(pills){
    const SF=H.products.filter(p=>p.cat==='single');
    const sn=p=>({'sin-sabor':'Sin sabor','mix':'Variado'}[p.id]||p.name);
    let cur=SF[0];
    const pickName=$('#subPickName');
    pills.innerHTML=SF.map((p,i)=>`<button class="sf-pill${i===0?' active':''}" data-id="${p.id}" style="--swatch:${p.swatch}"><span class="sf-ic">${fruitMini(p)}</span>${sn(p)}</button>`).join('');
    const subSect=$('#suscripcion');
    function pick(id){
      cur=H.getProduct(id);
      $$('.sf-pill',pills).forEach(b=>b.classList.toggle('active',b.dataset.id===id));
      if(pickName) pickName.textContent=cur.name;
      if(subSect){ subSect.style.setProperty('--flavor', cur.swatch); subSect.classList.toggle('is-mix', cur.id==='mix'); }
    }
    $$('.sf-pill',pills).forEach(b=>b.addEventListener('click',()=>pick(b.dataset.id)));
    const buyOnce=$('#buyOnce'), buyPlan=$('#buyPlan');
    buyOnce&&buyOnce.addEventListener('click',()=>H.addToCart(cur.name+' · bolsa 16 sticks',cur.price,false,cur.img,1,cur.id));
    buyPlan&&buyPlan.addEventListener('click',()=>H.addToCart(cur.name+' · suscripción',subPrice(cur),true,cur.img,1,cur.id));
    pick(SF[0].id);
  }

  /* Reseñas: estrellas tipo Trustpilot + carrusel rotatorio (datos compartidos) */
  const tpBig=$('#tpStarsBig'); if(tpBig) tpBig.innerHTML=H.tpStars(4.6);
  const track=$('#reviewTrack');
  if(track){
    const RV=(window.HYDRUP_DATA && window.HYDRUP_DATA.reviews && window.HYDRUP_DATA.reviews.length)?window.HYDRUP_DATA.reviews:H.REVIEWS;
    track.innerHTML=RV.map(rv=>`<article class="review">
      <div class="r-top"><span class="tp-stars">${H.tpStars(rv.r)}</span><span class="r-verif"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg> Compra verificada</span></div>
      <p>"${rv.txt}"</p>
      <div class="who"><span class="av" style="background:var(--accent)">${rv.av}</span><div><strong>${rv.n}</strong><span>${rv.t}</span></div></div>
    </article>`).join('');
    let rIdx=0, rTimer;
    function rNext(){const c=track.children; if(!c.length) return; rIdx=(rIdx+1)%c.length; const left=c[rIdx].offsetLeft-c[0].offsetLeft; track.scrollTo({left:left,behavior:'smooth'});}
    function rStart(){ rTimer=setInterval(rNext,4500); }
    function rStop(){ clearInterval(rTimer); }
    rStart();
    track.addEventListener('mouseenter',rStop); track.addEventListener('mouseleave',rStart);
    track.addEventListener('touchstart',rStop,{passive:true});
  }

  /* Estrellas del rating del hero */
  const heroStars=$('#heroStars'); if(heroStars && H.tpStars) heroStars.innerHTML=H.tpStars(4.6);

  /* Blog: últimas entradas — rellena solo si Liquid no renderizó nada (fallback) */
  const blogLatest=$('#blogLatest');
  if(blogLatest && !blogLatest.children.length && window.HYDRUP_BLOG){
    /* Fallback (sin artículos reales asignados): muestra las entradas demo, pero en Shopify
       redirige al blog real (/blogs/hidratacion) en vez de a post.html (que no existe en Shopify). */
    blogLatest.innerHTML=window.HYDRUP_BLOG.posts.slice(0,3).map(window.HYDRUP_BLOG.card).join('');
    if(window.HYDRUP_SHOPIFY && window.HYDRUP_SHOPIFY.enabled){ $$('#blogLatest .bpost').forEach(a=>a.setAttribute('href','/blogs/hidratacion')); }
  }

  H.initCart();
  })();
});
